import { useState, useCallback } from "react";
import { Minus } from "@phosphor-icons/react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { format } from "date-fns";
import { es } from "date-fns/locale";

export default function ConsumptionForm({ onSubmit }) {
  const [form, setForm] = useState({
    fecha: new Date(),
    articulo: "",
    cantidad: ""
  });
  const [dateOpen, setDateOpen] = useState(false);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    if (!form.articulo || !form.cantidad) {
      toast.error("Por favor, completa todos los campos");
      return;
    }

    const success = await onSubmit({
      fecha: format(form.fecha, "yyyy-MM-dd"),
      articulo: form.articulo.trim().toUpperCase(),
      cantidad: parseFloat(form.cantidad)
    });

    if (success) {
      setForm({ fecha: new Date(), articulo: "", cantidad: "" });
    }
  }, [form, onSubmit]);

  const handleDateSelect = useCallback((date) => {
    setForm(prev => ({ ...prev, fecha: date || new Date() }));
    setDateOpen(false);
  }, []);

  const handleInputChange = useCallback((field) => (e) => {
    setForm(prev => ({ ...prev, [field]: e.target.value }));
  }, []);

  return (
    <form onSubmit={handleSubmit} className="form-grid mb-6">
      <div className="space-y-2">
        <Label>Fecha</Label>
        <Popover open={dateOpen} onOpenChange={setDateOpen}>
          <PopoverTrigger asChild>
            <Button
              variant="outline"
              data-testid="consumption-date-btn"
              className="w-full justify-start text-left font-normal"
            >
              {format(form.fecha, "dd/MM/yyyy", { locale: es })}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0">
            <Calendar
              mode="single"
              selected={form.fecha}
              onSelect={handleDateSelect}
              initialFocus
            />
          </PopoverContent>
        </Popover>
      </div>
      <div className="space-y-2">
        <Label>Artículo</Label>
        <Input
          data-testid="consumption-articulo-input"
          placeholder="Nombre del artículo"
          value={form.articulo}
          onChange={handleInputChange("articulo")}
        />
      </div>
      <div className="space-y-2">
        <Label>Cantidad</Label>
        <Input
          data-testid="consumption-cantidad-input"
          type="number"
          step="0.01"
          placeholder="0"
          value={form.cantidad}
          onChange={handleInputChange("cantidad")}
        />
      </div>
      <div className="col-span-full">
        <Button 
          data-testid="add-consumption-btn"
          type="submit" 
          className="bg-slate-900 text-white hover:bg-slate-800"
        >
          <Minus size={16} className="mr-2" />
          Registrar Consumo
        </Button>
      </div>
    </form>
  );
}
